
import { WeGoConfig } from './../../shared/config';
import { Http, RequestOptions, ResponseContentType } from '@angular/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { AuthService } from "../../shared/models/auth.service";
import { IAPIResponse } from "../../shared/config";
import { JQueryHelperService } from './../../shared/models/jquery-helper.service';
import { SnailTrailDriverSearchModel } from './snail-trail-search.model';

@Injectable()
export class SnailTrailDriverService {
  JQueryHelper: JQueryHelperService = new JQueryHelperService();
  constructor(private authService: AuthService, private http: Http) { }

  public GetSnailTrail(searchModel: SnailTrailDriverSearchModel): Observable<IAPIResponse> {
    let body = searchModel;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http.post(WeGoConfig.API_POST_SEARCH_SNAIL_TRAIL, body, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public ExportSnailTrailExcel(model: SnailTrailDriverSearchModel): any {
    let getUrl = WeGoConfig.API_GET_SEARCH_SNAIL_TRAIL_CSV;
     
    let queryString = this.JQueryHelper.Param(model);
    getUrl=getUrl + "?" + queryString;

    let headers = this.authService.GetHeader('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
    let options = new RequestOptions({ headers: headers, responseType: ResponseContentType.Blob });


    return this.http.get(getUrl, options);
  }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/snail-trail-driver/models/snail-trail-driver.service.ts